import React, { useCallback, useEffect, useState } from 'react';

import { usePrincipalUser } from '@atlassian/ptc-common';
import { useActivityClient } from '@atlassian/recent-work-client';
import { useTeamsUser } from '@atlassian/teams/user';

import { type Activity } from '../../models/ActivityObject';
import { transformDataFromRecentWorkClient } from '../WorkedOn/recentWorkTransformers';

import ProfileWorkList from './ProfileWorkList';
import { type WithQueryProps } from './types';

const ProfileRecentWorkClient = (props: WithQueryProps) => {
	const { userId } = props;
	const [{ principalUserId }] = usePrincipalUser();
	const [activities, setActivities] = useState<Activity[]>([]);
	const [error, setError] = useState(undefined);
	const [isLoading, setIsLoading] = useState(true);

	const activityClient = useActivityClient('v3', 'people');

	const { data } = useTeamsUser(userId, !userId);

	const loadActivities = useCallback(async () => {
		setIsLoading(true);

		try {
			const fetchedActivities = await activityClient.fetchActivities(
				[50, 125, 250], // retries
				{
					limit: 50,
					actors: [`ari:cloud:identity::user/${userId}`],
				},
				['workedOn'],
			);

			const translated = transformDataFromRecentWorkClient(fetchedActivities.workedOn);

			setActivities(translated);
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			// @ts-ignore
			setError(error);
		}
	}, [activityClient, userId]);

	useEffect(() => {
		if (userId) {
			loadActivities();
		}
	}, [loadActivities, userId]);

	return (
		<ProfileWorkList
			userFullName={data?.fullName}
			userId={userId}
			currentUserId={principalUserId}
			error={error}
			hasError={!!error}
			isLoading={isLoading}
			activities={activities}
		/>
	);
};

export default ProfileRecentWorkClient;
